module.exports = __webpack_public_path__ + "static/media/search-black-icon.a9b4f323.svg";